import { jsx as _jsx } from "react/jsx-runtime";
import { PageHeader, PageFooter } from "@/components/organisms";
import { StandardPageTemplate } from "@/components/templates";
import { useLocation } from "react-router-dom";
import { InternetThankYouPage, SimOnlyThankYouPage, StreamingThankYouPage, } from "./pages";
const ThankYouPageByCheckout = () => {
    const { state } = useLocation();
    const { checkoutType } = state ?? {
        checkoutType: undefined,
    };
    switch (checkoutType) {
        case "internet":
            return _jsx(InternetThankYouPage, {});
        case "simOnly":
            return _jsx(SimOnlyThankYouPage, {});
        case "streaming":
            return _jsx(StreamingThankYouPage, {});
        default:
            return _jsx(InternetThankYouPage, {});
    }
};
const ThankYouPage = () => {
    return (_jsx(StandardPageTemplate, { header: _jsx(PageHeader, { itemCount: 1 }), sections: [_jsx(ThankYouPageByCheckout, {}, "thankYouSection")], footer: _jsx(PageFooter, {}) }));
};
export default ThankYouPage;
